import styled from 'styled-components';

const TradingContent = styled.div`
  flex: 1 1 auto;
`;

export default TradingContent;
